// extracted by mini-css-extract-plugin
export default {"container":"profile_container__DMByV","form":"profile_form__oDS-V"};